import { mergeStates } from '../../../iwProvider/StoreHelper';
import { ACTIVATE_ACCOUNT_HISTORY } from '../../accountHistory/AccountHistory.actions';
import { ACTIVATE_FLEXI12_DASHBOARD } from '../../dashboard/Dashboard.actions';
import { ACTIVATE_DRAW_DOWN } from '../../drawDown/DrawDown.actions';
import { ACTIVATE_EARLY_REPAYMENT } from '../../earlyRepayment/EarlyRepayment.actions';
import { ACTIVATE_PAGE_NOT_FOUND } from '../../pageNotFound/PageNotFound.actions';
import { ACTIVATE_TRADING_DATA } from '../../tradingData/TradingData.actions';
import { ACTIVATE_PROFILE } from '../../Profile/Profile.actions';
import { ACTIVATE_SECOND_CBILS_DASHBOARD } from '../../CBILS/secondCBILSDashboard/SecondCBILSDashboard.actions';
import { ACTIVATE_RLS_DASHBOARD } from '../../RLS/dashboard/Dashboard.actions';
import { ACTIVATE_RBL_DASHBOARD } from '../../revenueBasedLoan/dashboard/Dashboard.actions';
import { ACTIVATE_FLEXI24_DASHBOARD } from '../../flexi24/dashboard.actions';
import { ACTIVATE_TERM_LOAN_DASHBOARD } from '../../termLoan/Dashboard.actions';
import { TERM_LOAN_PAGE_NAME } from '../../termLoan/Dashboard.sagas';
import { FLEXI_12_PAGE_NAME } from '../../dashboard/Dashboard.sagas';
import { FLEXI_24_PAGE_NAME } from '../../flexi24/dashboard.saga';
import { ACTIVATE_MY_OFFERS } from '../../myOffers/MyOffers.actions';
import { MY_OFFERS_PAGE_NAME } from '../../myOffers/MyOffers.sagas';

const initialState = {
    activePage: ''
};

// eslint-disable-next-line import/no-default-export
export default function (state = mergeStates(initialState), action = {}) {
    // Reset the activePage when leaving a page.
    if ((action.type || '').endsWith('[leaving]')) {
        return { activePage: '' };
    }

    switch (action.type) {
        case ACTIVATE_FLEXI12_DASHBOARD:
            return { activePage: FLEXI_12_PAGE_NAME };
        case ACTIVATE_FLEXI24_DASHBOARD:
            return { activePage: FLEXI_24_PAGE_NAME };
        case ACTIVATE_TERM_LOAN_DASHBOARD:
            return { activePage: TERM_LOAN_PAGE_NAME };
        case ACTIVATE_SECOND_CBILS_DASHBOARD:
            return { activePage: 'SECOND_CBILS_DASHBOARD' };
        case ACTIVATE_RLS_DASHBOARD:
            return { activePage: 'RLS_DASHBOARD' };
        case ACTIVATE_RBL_DASHBOARD:
            return { activePage: 'RBL_DASHBOARD' };
        case ACTIVATE_TRADING_DATA:
            return { activePage: 'TRADING_DATA' };
        case ACTIVATE_ACCOUNT_HISTORY:
            return { activePage: 'ACCOUNT_HISTORY' };
        case ACTIVATE_PROFILE:
            return { activePage: 'PROFILE' };
        case ACTIVATE_MY_OFFERS:
            return { activePage: MY_OFFERS_PAGE_NAME };
        case ACTIVATE_DRAW_DOWN:
            return { activePage: 'DRAW_DOWN' };
        case ACTIVATE_EARLY_REPAYMENT:
            return { activePage: 'EARLY_REPAYMENT' };
        case ACTIVATE_PAGE_NOT_FOUND:
            return { activePage: 'PAGE_NOT_FOUND' };
        default:
            return state;
    }
}
